import { Directive, Injector, Optional } from '@angular/core';
import { DynamicComponentRefProvider, runtimeEventManager } from "@wm/core";
import {
  APPLY_STYLES_TYPE,
  IWidgetConfig,
  provideAsWidgetRef,
  register,
  StylableComponent,
  styler,
  Parent
} from '@wm/components-base';

const DEFAULT_CLS = 'app-linear-layout-item clearfix';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-linearlayoutitem',
  hostClass: DEFAULT_CLS
};
@Directive({
  selector: '[wmLinearLayoutitem]',
  standalone: true,
  exportAs: 'wmLinearLayoutitem',
  providers: [
    provideAsWidgetRef(LinearLayoutItemDirective)
  ]
})
export class LinearLayoutItemDirective extends StylableComponent {
  static initializeProps = register('wm-linearlayoutitem');
  private dynamicComponentProvider: DynamicComponentRefProvider;
  constructor(inj: Injector, @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this, APPLY_STYLES_TYPE.CONTAINER);
    this.dynamicComponentProvider = runtimeEventManager.getService('dynamicComponentRefProvider');
  }
  protected override onPropertyChange(key: string, nv: any, ov?: any) {
    switch (key) {
      case 'flexgrow':
        this.$element.css('flex-grow', nv);
        break;
    }
    super.onPropertyChange(key, nv, ov);
  }

  async buildActionPanel(el: any, actionLocation: any) {
    let pScope: any = {}
    pScope.actions = this.getDesignActions(this, el, actionLocation);
    var template = '<wms-design-quick-actions [actions]="actions"/>';
    let element = await this.dynamicComponentProvider.addComponentBasedOnSelector(null, template, pScope, {}).then((el: HTMLElement) => {
      return el;
    });
    return element;
  }

  private getDesignActions($scope: any, $el: any, actionLocation: any) {
    const root = this;
    return [{
      'name': 'add',
      'icon': 'wms wms-plus',
      'onClick': function (event: any) {
        event.stopPropagation();
        root.addItem($scope, $el, actionLocation);
      }
    }];
  }

  private addItem($scope: any, $el: any, actionLocation: any, widgetIdToAdd?: any) {
    var widgetId = $el.attr('widgetid');
    var direction = $el.closest('.app-linear-layout')[0].widget.direction;
    var isRow = direction === 'row' || direction === 'row-reverse';
    if (actionLocation === 'bottom' && isRow) {
      runtimeEventManager.emit('canvas-add-widget', {
        parentId: widgetId,
        widgetType: 'wm-linear-v-layout',
        'isAtomicAction': false
      });
      this.moveContent($scope, $el, widgetIdToAdd);
    } else if (actionLocation === 'right' && !isRow) {
      runtimeEventManager.emit('canvas-add-widget', {
        parentId: widgetId,
        widgetType: 'wm-linear-h-layout',
        'isAtomicAction': false
      });
      this.moveContent($scope, $el, widgetIdToAdd);
    } else if (actionLocation === 'right' || actionLocation === 'bottom') {
      runtimeEventManager.emit('canvas-add-widget', {
        'referenceId': widgetId,
        'referencePos': 'after',
        'parentId': $el.parent().attr('widgetid'),
        'widgetType': 'wm-linearlayoutitem',
        'widgetDefaults': {
          'flexgrow': $scope.flexgrow
        },
        'isAtomicAction': false
      });
      if (widgetIdToAdd) {
        runtimeEventManager.emit('canvas-move-widget', {
          'parentId': $el.next().attr('widgetid'),
          'prevParentId': widgetId,
          'widgetId': widgetIdToAdd,
          'isAtomicAction': false
        });
      }
    }
  }

  private moveContent($scope: any, $el: any, childToMove: any) {
    var targetWidgetId = $el.find('>.app-linear-layout:last>.app-linear-layout-item:first').attr('widgetid');
    var widgetId = $el.attr('widgetid');
    if (childToMove) {
      runtimeEventManager.emit('canvas-move-widget', {
        'parentId': $el.find('>.app-linear-layout:last>.app-linear-layout-item:last').attr('widgetid'),
        'prevParentId': widgetId,
        'widgetId': childToMove,
        'isAtomicAction': false
      });
    }
    $el.children().not('.app-linear-layout:last').each(function () {
      runtimeEventManager.emit('canvas-move-widget', {
        'parentId': targetWidgetId,
        'prevParentId': widgetId,
        'widgetId': widgetId, // $(this).attr('widgetid'),
        'isAtomicAction': false
      });
    });
  }
}
